import React from 'react';
import MagazineViewer from '../components/MagazineViewer';

function PortfolioViewer() {
  return (
    <div className="portfolio-viewer-page">
      <MagazineViewer />
    </div>
  );
}

export default PortfolioViewer;
